export const logCommitHash = () => {
  try {
    console.log(
      'COMMIT_HASH:',
      typeof process.env.GIT_COMMITHASH === 'string' ? process.env.GIT_COMMITHASH : 'Failed to get commit hash',
    );
  } catch (error) {
    console.log('ERROR GETTING COMMIT HASH:', error);
  }
};

export const logReleaseVersion = () => {
  try {
    console.log(
      'RELEASE_VERSION:',
      typeof process.env.RELEASE_VERSION === 'string' ? process.env.RELEASE_VERSION : 'Failed to get release version',
    );
  } catch (error) {
    console.log('ERROR GETTING RELEASE VERSION:', error);
  }
};

export const logFriendlyBenzingaMessageToDevelopers = () => {
  console.log(`______                _
| ___ \\              (_)
| |_/ / ___ _ __  _____ _ __   __ _  __ _
| ___ \\/ _ \\ '_ \\|_  / | '_ \\ / _\` |/ _\` |
| |_/ /  __/ | | |/ /| | | | | (_| | (_| |
\\____/ \\___|_| |_/___|_|_| |_|\\__, |\\__,_|
                               __/ |
                              |___/      `);

  console.log("Hey! If you're here and would like to apply: https://jobs.benzinga.com");
};
